<template lang="pug">
  v-card.round-lg.pa-4(outlined)
    v-row.mb-3(no-gutters align="center")
      v-col
        .text-xs.neutral500--text.font-semibold Offers
      v-spacer
      v-col.text-right
        v-btn.button-xs.neutral700--text.border-gray.round-2xl(outlined :disabled="disableViewAll" @click="handleViewAll") View all
    v-row(no-gutters align="center")
      template(v-if="coupons.isFetching")
        v-col.text-center
          v-skeleton-loader(type="list-item-two-line")
      template(v-else)
        template(v-if="coupons.data.length === 0")
          v-col
            .text-xs.neutral500--text No available offers
        template(v-else v-for="(coupon, idx) in coupons.data")
          v-col.mb-2(cols="6" :class="[{ 'pr-2': idx === 0 }, { 'pl-2': idx === 1 }]")
            offers-card-items(:title="coupon.offer.name" :subtitle="coupon.code" @apply="handleViewOne(idx)")
    .dialogs
      redeem-offer-dialog(v-if="redeemOffers.open" :open.sync="redeemOffers.open" :customer="customer" :lead-id="leadId" @updated="handleUpdated")
      redeem-one-offer-dialog(v-if="redeemOneOffer.open" :open.sync="redeemOneOffer.open" :offer="redeemOneOffer.data" :customer="customer" :lead-id="leadId" @updated="handleUpdated")
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OffersCardItems from "@/components/clinic/checkout/marketing/OffersCardItems.vue";
import RedeemOfferDialog from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferDialog.vue";
import RedeemOneOfferDialog from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOneOfferDialog.vue";

export default {
  components: {
    RedeemOneOfferDialog,
    RedeemOfferDialog,
    OffersCardItems
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    leadId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      coupons: {
        isFetching: true,
        data: [],
      },
      redeemOffers: {
        open: false,
      },
      redeemOneOffer: {
        open: false,
        data: null
      },
    }
  },
  mounted() {
    this.fetchOffers()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disableViewAll() {
      return this.coupons.isFetching || this.coupons.data.length === 0
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleViewAll() {
      this.redeemOffers.open = true
    },
    handleViewOne(itemIndex) {
      this.redeemOneOffer.data = this.coupons.data[itemIndex]
      this.redeemOneOffer.open = true
    },
    async fetchOffers() {
      const url = `/marketing/${this.company.slug}/coupons`
      const params = {
        customer: this.customer.id,
        lead: this.leadId,
        ordering: 'expired_at',
        page_size: 2,
      }
      try {
        this.coupons.isFetching = true
        const {data} = await this.$axios.get(url, {params})
        this.coupons.data = data.results
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.coupons.isFetching = false
      }
    },
    handleUpdated() {
      this.fetchOffers()
      this.$emit('updated')
    }
  },
}
</script>

<style scoped>
.border-gray {
  border-color: #c1c1c1;
}
</style>